'use client';

import * as React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { TableCell, TableRow } from '@/components/ui/table';

type ReportsTableSkeletonProps = {
  rows?: number;
};

export function ReportsTableSkeleton({ rows = 8 }: ReportsTableSkeletonProps) {
  return (
    <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
      <>
        {Array.from({ length: rows }, (_, index) => (
          <TableRow key={index}>
            <TableCell className="w-10">
              <Skeleton height={16} width={16} />
            </TableCell>
            <TableCell>
              <Skeleton height={16} width={240} />
            </TableCell>
            <TableCell className="w-32">
              <Skeleton height={20} width={88} borderRadius="0.375rem" />
            </TableCell>
            <TableCell className="w-28">
              <Skeleton height={20} width={72} borderRadius="0.375rem" />
            </TableCell>
            <TableCell className="w-36">
              <Skeleton height={14} width={100} />
            </TableCell>
            <TableCell className="w-28">
              <Skeleton height={14} width={80} />
            </TableCell>
            <TableCell className="w-12">
              <Skeleton height={16} width={16} />
            </TableCell>
          </TableRow>
        ))}
      </>
    </SkeletonTheme>
  );
}
